import React from 'react';
import { XCircleIcon, CheckCircle2Icon, ArrowDownIcon } from 'lucide-react';
import { beforeItems, afterItems } from '../data/content';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
export function BeforeAfter() {
  return <section className="w-full bg-white px-4 py-14 md:py-20" data-id="element-33" data-mp="3shcw2bmkxl9e">
      <div className="mx-auto max-w-6xl" data-id="element-34" data-mp="3sfs14kwcs0b0">
        <SectionHeading kicker="A more structured way to approach pediatric orthodontic cases" title="From uncertainty… to a clearer clinical decision-making process" intro={<p data-id="element-36" data-mp="34sagraff44i2">
              Treating children requires more than recognizing a dental problem. You need to consider growth and
              development, the stage of dentition, occlusal relationships, the underlying problem, and the benefits and
              limitations of each treatment approach.
            </p>} data-id="element-35" data-mp="3eq83fthmpt8k" />

        <div className="relative mt-10 grid gap-5 md:grid-cols-2 md:gap-6" data-id="element-37" data-mp="30pnk8w7sxvej">
          <div className="rounded-3xl border-2 border-danger-line bg-danger-soft p-5 sm:p-7" data-id="element-38" data-mp="x3sfkakpx2qk">
            <div className="mb-5 flex items-center gap-3" data-id="element-39" data-mp="t3qdi0b2m7ar">
              <span className="rounded-full bg-danger px-4 py-1.5 font-display text-lg font-extrabold uppercase tracking-wide text-white" data-id="element-40" data-mp="t5b81pxdxq8m">
                Before
              </span>
              <span className="text-sm font-semibold text-danger" data-id="element-41" data-mp="124gah7c2i3q2">Without a structured framework</span>
            </div>
            <ul className="space-y-4" data-id="element-42" data-mp="9eziubw9uquw">
              {beforeItems.map(item => <li key={item} className="flex gap-3" data-id="element-43" data-mp="9cwl15ovntfm">
                  <XCircleIcon className="mt-0.5 h-6 w-6 shrink-0 text-danger" aria-hidden="true" data-id="element-44" data-mp="o4xbb418i2pw" />
                  <span className="text-base leading-snug text-ink" data-id="element-45" data-mp="jc466f1ussda">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="flex justify-center md:hidden" aria-hidden="true" data-id="element-46" data-mp="3rqmac5oobnrm">
            <span className="flex h-12 w-12 items-center justify-center rounded-full bg-navy text-white" data-id="element-47" data-mp="3mtm2pqc6ecye">
              <ArrowDownIcon className="h-6 w-6" data-id="element-48" data-mp="1qon2fur2jv0n" />
            </span>
          </div>

          <div className="rounded-3xl border-2 border-success-line bg-success-soft p-5 sm:p-7" data-id="element-49" data-mp="1vo9fo46wdb9g">
            <div className="mb-5 flex items-center gap-3" data-id="element-50" data-mp="20h2iunmpwbjf">
              <span className="rounded-full bg-success px-4 py-1.5 font-display text-lg font-extrabold uppercase tracking-wide text-white" data-id="element-51" data-mp="24inrfws7y3nt">
                After
              </span>
              <span className="text-sm font-semibold text-success" data-id="element-52" data-mp="1cqop8sohi4mq">With the Blueprint™</span>
            </div>
            <ul className="space-y-4" data-id="element-53" data-mp="1gs1wn7786fvr">
              {afterItems.map(item => <li key={item} className="flex gap-3" data-id="element-54" data-mp="1lrmwdju7ys9j">
                  <CheckCircle2Icon className="mt-0.5 h-6 w-6 shrink-0 text-success" aria-hidden="true" data-id="element-55" data-mp="1lt7qx9gjab7e" />
                  <span className="text-base font-medium leading-snug text-ink" data-id="element-56" data-mp="2s7gs26jsczor">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <blockquote className="mx-auto mt-10 max-w-3xl border-l-4 border-teal pl-5 text-lg italic leading-relaxed text-navy" data-id="element-57" data-mp="379oynqm6bwv6">
          I don't want you to memorize another collection of disconnected facts. I want to help you organize the
          knowledge you already have into a more systematic clinical decision-making process.
        </blockquote>

        <CTAButton className="mt-10" label="Get my decision blueprint" subtext="Only $27 USD · Instant access" data-id="element-58" data-mp="2ok8vevj3tqb2" />
      </div>
    </section>;
}